import tw from 'twin.macro';

export const FooterContainer = tw.footer`w-full p-4 md:p-8 bg-green block`;
export const FooterFlex = tw.div`flex items-center justify-center gap-4`;
export const LinkIcon = tw.a`block text-black hover:text-red`;
